import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Link from "@material-ui/core/Link";

// @material-ui/icons
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
import Box from "@material-ui/core/Box";
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import TextField from "@material-ui/core/TextField";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';

import config from "constants/config.js";
import apiService from "services/apiService.js";

const useStyles = makeStyles(styles);

export default function ResetPasswordPage(props) {
  const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
  React.useEffect(() => {
    let id = setTimeout(function() {
      setCardAnimation("");
    }, 700);
    // Specify how to clean up after this effect:
    return function cleanup() {
      window.clearTimeout(id);
    };
  });
  const classes = useStyles();

  const token = props.match.params?props.match.params.token:"";

  const [email, setEmail] = React.useState("");

  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  const [isSuccess, setIsSuccess] = React.useState(false);

  React.useEffect(() => {
    ValidatorForm.addValidationRule('isPasswordMatch', (value) => {
      if (value !== password) {
          return false;
      }
      return true;
    });

    return () => {
      ValidatorForm.removeValidationRule('isPasswordMatch');
    }
  })

  const resetPassword = function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const password = e.target.password.value;
    const confirm_password = e.target.confirm_password.value;

    const data = {
      password,
      token
    };

    apiService(config.endpoint.resetPassword, 'POST', data, function(response) {
      // console.log('here');
      console.log(response);
      setIsSuccess(true);
    }, function(error) {
      console.log(error);
    })
  }

  return (
    <div className={classes.container}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={6} md={6}>
          <ValidatorForm 
            onSubmit={resetPassword}
            >
            {(!isSuccess) && <Card login className={classes[cardAnimaton] + " " + classes.loginCard}>
              <CardHeader className={classes.cardHeader}>
                <h4 className={classes.cardTitle}>Reset Your Password</h4>
                <p>Create a new password below</p>
              </CardHeader>
              <CardBody className={classes.cardBody}>
                <TextValidator 
                  id="password"
                  name="password"
                  type="password"
                  label="Password"
                  variant="outlined"
                  fullWidth={true}
                  className={classes.input}
                  validators={['required']}
                  errorMessages={['This field is required']}
                  value={password}
                  onChange={e => {
                    setPassword(e.target.value);
                  }}
                  />
                <TextValidator 
                  name="confirm_password"
                  type="password"
                  label="Confirm"
                  variant="outlined"
                  fullWidth={true}
                  className={classes.input}
                  validators={['isPasswordMatch', 'required']}
                  errorMessages={['password mismatch', 'this field is required']}
                  value={confirmPassword}
                  onChange={e => {
                    setConfirmPassword(e.target.value);
                  }}
                  />
              </CardBody>
              <CardFooter className={classes.cardFooter}>
                <GridContainer justify="center">
                  <GridItem xs={12}>
                    <Button size="lg" type="submit" className={classes.loginButton}>
                      Reset Password
                    </Button>
                  </GridItem>
                  <GridItem xs={12}>
                    <Box m={1}>
                      <Link href="/admin/login" className={classes.forgotPassword}>
                        Log In
                      </Link>
                    </Box>
                  </GridItem>
                  <GridItem xs={12}>
                    <Link href="/admin/register" className={classes.forgotPassword}>
                      Create Your Account
                    </Link>
                  </GridItem>
                </GridContainer>
              </CardFooter>
            </Card>}
            {(isSuccess) && <Card login className={classes[cardAnimaton] + " " + classes.loginCard}>
            <CardHeader className={classes.cardHeader}>
              <h4 className={classes.cardTitle}>Thank you! Your password has been changed.</h4>
            </CardHeader>
            <CardFooter className={classes.cardFooter}>
              <GridContainer justify="center">
                <GridItem xs={12}>
                  <Button size="lg" className={classes.loginButton} onClick={e => {
                    props.history.push('/admin/login');
                  }}>
                    Login
                  </Button>
                </GridItem>
              </GridContainer>
            </CardFooter>
          </Card>}
          </ValidatorForm>
        </GridItem>
      </GridContainer>
    </div>
  );
}
